<template>
  <div>
    <v-dialog v-model="dialog" persistent max-width="600px">
      <template v-slot:activator="{ on }">
        <v-btn color="white black--text" dark v-on="on">{{text}}</v-btn>
      </template>
      <v-card>
        <v-card-title>
          <span v-if="!loggedIn" class="headline">Welcome Back</span>
        </v-card-title>
          <v-alert
      v-model="showError"
      :dismissible="false"
      type="error"     
      class="mb-4"
    >Login Failed:<br>{{errorMessage}}</v-alert>

        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12>
                <v-text-field
                 v-if="!loggedIn"
                  v-model="email"
                  :error-messages="emailErrors"
                  label="E-mail*"
                  required
                  @input="$v.email.$touch()"
                  @blur="$v.email.$touch()"
                ></v-text-field>
              </v-flex>

              <v-flex xs12>
                <v-text-field
                  v-if="!loggedIn"
                  label="Password*"
                  type="password"
                  v-model="password"
                  required
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
          <small v-if="!loggedIn">*indicates required field</small>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="close()">CLOSE</v-btn>
          <v-btn color="blue darken-1" text @click="action()">{{buttonPopup}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
const fb = require("../firebaseConfig.js");
import { validationMixin } from "vuelidate";
import { required, maxLength, email } from "vuelidate/lib/validators";
import Vue from "vue";
export default {
  mixins: [validationMixin],
  data: () => ({
    dialog: false,
    username: "",
    email: "",
    password: "",
    showError:false,
    errorMessage:""
    //loggedIn: false,
    //text: "SIGN IN",
   // buttonPopup: "SIGN IN"
  }),
  validations: {
    email: { required, email },
    select: { required }
  },
  mounted() {
    localStorage.removeItem("token");
  },
  computed: {
    emailErrors() {
      const errors = [];
      if (!this.$v.email.$dirty) return errors;
      !this.$v.email.email && errors.push("Must be valid e-mail");
      !this.$v.email.required && errors.push("E-mail is required");
      return errors;
    },
     loggedIn(){
      return this.$store.state.currentUser != null;
    },
    text(){
      if(this.loggedIn){
        return "SIGN OUT";
      }
      else{
        return "SIGN IN";
      }
    },
    buttonPopup(){
      if(this.loggedIn){
        return "SIGN OUT";
      }
      else{
        return "SIGN IN";
      }
    }

  },
  methods: {
    openDialog() {
      this.dialog = true;
    },
    close() {
      this.dialog = false;
    },
    action() {
      if (this.loggedIn) {
        this.logout();
      } else {
        this.login();
      }
      this.username = "";
      this.password = "";
    },
    async logout() {
      //localStorage.removeItem("token");
      //this.$emit("logger");
      await fb.auth.signOut()
      this.dialog = false;
      
      this.$store.dispatch("clearData");

   
     // this.text = "SIGN IN";

      if (this.$router.currentRoute.path === "/editor") {
        this.$router.push("/");
      }

      setTimeout(() => {
        //this.loggedIn = false;
        //this.buttonPopup = "SIGN IN";
      }, 100);
    },
    login() {
      if (this.email !== undefined && this.password !== undefined)
        if (this.email !== "" && this.password !== "") {
          if (this.doLogin(this.email, this.password)) {
            // this.dialog = false;
            // this.text = "SIGN OUT";

            // setTimeout(() => {
            //   this.loggedIn = true;
            //   this.buttonPopup = "SIGN OUT";
            // }, 100);
          } else {
            alert(`Try Again or Close`);
          }
        }
    },
    doLogin(email, password) {
      fb.auth
        .signInWithEmailAndPassword(email, password)
        .then(user => {
          this.$store.commit("setCurrentUser", user.user);
          this.$store.dispatch("fetchUserProfile");

    
      if (this.$router.currentRoute.path !== "/editor") {

this.$router.push("/editor");
      }else{
                       this.$store.dispatch("forceEditorRefresh");
      }
        
            
            this.dialog = false;
           // this.text = "SIGN OUT";

            setTimeout(() => {
            //  this.loggedIn = true;
             // this.buttonPopup = "SIGN OUT";


            }, 100);

       this.errorMessage = "";
          this.showError = false;
        })
        .catch(err => {
          this.errorMessage = err.message;
          this.showError = true;
          console.log(err);
        });
      //Add editor
      // if (email == "test@test.com" && password == "test") {
      //   localStorage.setItem("token", "l23");
      //   this.$emit("logger");
      //   if (this.$router.currentRoute.path !== "/editor") {
      //     this.$router.push("/editor");
      //   }
      //   return true;
      // }

       return true;
    }
  }
};
</script>